/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { MutationUpsertTaskArgs } from '../gql/graphql';
import { GET_SUBMISSION } from './submission.query';
import { GET_TASKS } from './tasks.query';

export function useUpsertTaskMutation(
  options: MutationHookOptions<any, MutationUpsertTaskArgs> = {}
) {
  const [upsertTask, { loading, error, reset, data }] = useMutation(
    graphql(`
      mutation upsertTask($details: TaskInput!) {
        upsertTask(details: $details) {
          uuid
          tenant
        }
      }
    `),
    {
      ...options,
      refetchQueries: [GET_SUBMISSION, GET_TASKS],
      awaitRefetchQueries: true,
    }
  );

  return {
    upsertTask,
    loading,
    error,
    reset,
    data,
  };
}
